import { render } from "./Models.vue?vue&type=template&id=be5fbe8a"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__